import { useLayoutEffect, useState } from 'react';

export const useTargetElement = (getElement) => {
  const [targetElement, setTargetElement] = useState<any>(null);

  useLayoutEffect(() => {
    const obs = new MutationObserver((_, observer) => {
      const element = getElement?.();

      if (element) {
        setTargetElement(element);
        observer.disconnect();
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });

    return () => obs.disconnect();
  }, [getElement]);

  return {
    targetElement,
  };
};
